module.exports = __webpack_public_path__ + "static/media/EC.36f93299.svg";